import { resolveMenuItemImageUrl } from './resolveMenuItemImageUrl'
import { MENU_ITEM_MODAL_IMAGE } from './MENU_ITEM_MODAL_IMAGE'

/** Start fetching the modal hero image as soon as the user opens an item. */
export function useMenuItemModalImagePreload() {
  const $img = useImage()

  return (item: Parameters<typeof resolveMenuItemImageUrl>[0]) => {
    const src = resolveMenuItemImageUrl(item)
    if (src == null || src === '' || !import.meta.client) return

    const url = $img(src, MENU_ITEM_MODAL_IMAGE)
    const image = new Image()
    image.src = url
  }
}
